import * as React from 'react';

import * as styles from './PageHeader.css';

interface IPageHeaderProps {
  title: string;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({ title }) => {
  return (
    <div className={styles['container']} data-name="PageHeader">
      <h1 className={styles['title']}>{title}</h1>
      <p className={styles['description']}>
        Собрали самые интересные предложения в новостройках — выбирайте лучшее и покупайте выгодно!
      </p>
    </div>
  );
};
